<template>
	<section class="bg-white">
		<Container
			class="flex flex-wrap xl:grid grid-cols-3 mx-auto gap-6 lg:border-b border-black/[.1] !py-6 !lg:py-9"
		>
			<div class="w-full col-span-2 mb-4 lg:mb-0">
				<NewsCard
					v-bind="posts[0]"
					card-type="featured"
				/>
			</div>

			<div class="flex flex-col gap-6 col-span-1 lg:pl-6">
				<div>
					<h2
						class="font-bold text-2xl lg:text-xl mb-4 pl-5 text-black border-l-[6px] leading-none border-blue-300"
					>
						Trending Stories
					</h2>

					<div class="pb-4 border-b border-slate-100 mb-3">
						<iframe
							title="most-active-iframe"
							src="https://develop.d2xx6vtf6inrnz.amplifyapp.com/small-grid?title=Most%20Active&prev_day_on_premarket=1&filter=VOLUME%20>%205000000%20AND%20MARKET_CAP%20>%202000000000%20AND%20MARKET%20IN%20(%27NGS%27,%27NYE%27,%20%27AMX%27)%20ORDER%20BY%20VOLUME%20DESC%20LIMIT%2010"
							width="360"
							height="240"
							frameborder="0"
							loading="lazy"
							class="block bg-slate-100 w-full h-full min-h-[240px] max-h-[240px] rounded-2xl mb-3"
						></iframe>

						<NuxtLink
							to="https://lp.stockstotrade.com/watchlist/?utm_source=blog&utm_medium=news_mention&utm_campaign=afP4MM"
							target="_blank"
						>
							<h2
								class="capitalize text-black font-bold text-2xl lg:text-xl mb-3 hover:underline"
							>
								Sign up for my weekly watchlist here!
							</h2>
						</NuxtLink>

						<div class="flex flex-wrap gap-2">
							<template
								v-for="ticker in list_of_symbols"
								:key="ticker"
							>
								<StockTicker
									:symbol="ticker.SYMBOL"
									:change="ticker.PC_CHG"
								/>
							</template>
						</div>

						<CtaButton
							class="mt-3"
							:full-width="true"
							:blank="true"
							to="https://lp.stockstotrade.com/watchlist/?utm_source=blog&utm_medium=news_mention&utm_campaign=afP4MM"
						>
							Join Now!
						</CtaButton>
					</div>

					<div class="flex flex-col gap-3">
						<NewsCard
							v-for="(news, index) in posts.slice(1, 4)"
							:key="news.slug"
							v-bind="news"
							card-type="tertiary"
							:no-border="index == 2"
						/>
					</div>
				</div>
			</div>
		</Container>
	</section>

	<section class="bg-white py-6 lg:py-9 border-b border-black/[.1]">
		<Container class="flex flex-wrap xl:flex-nowrap gap-6 mx-auto">
			<div class="w-full flex flex-col">
				<h2
					class="font-bold text-2xl lg:text-4xl pl-6 mb-3 lg:mb-8 text-black border-l-[6px] leading-none border-blue-300"
				>
					Latest News
				</h2>

				<NewsCard
					v-for="news in posts.slice(9, posts.length)"
					:key="news.slug"
					v-bind="news"
					card-type="list"
				/>

				<div
					ref="loadMoreAnchor"
					class="blog-loading-container"
				>
					<Loading v-if="showLoad" />
				</div>
			</div>

			<div class="rounded-2xl py-6 w-full max-w-[359px] h-fit sticky top-[92px]">
				<iframe
					title="top-gainers-iframe"
					src="https://develop.d2xx6vtf6inrnz.amplifyapp.com/small-grid"
					width="360"
					height="440"
					frameborder="0"
					loading="lazy"
					class="block bg-slate-100 w-full h-full min-h-[380px] max-h-[380px] rounded-2xl mb-3"
				></iframe>

				<!-- <template>

				<h2
					class="font-bold text-xl mb-4 pl-5 text-white border-l-[6px] leading-none border-yellow-300"
				>
					Top Picks for November
				</h2>

				<NewsCard
					card-type="trending-list"
					title="Pre-market trading offers a unique opportunity for investors to react to news"
				/>
				<NewsCard
					card-type="trending-list"
					title="Pre-market trading offers a unique opportunity for investors to react to news"
				/>
				<NewsCard
					card-type="trending-list"
					title="Pre-market trading offers a unique opportunity for investors to react to news"
				/>
				<NewsCard
					card-type="trending-list"
					title="Pre-market trading offers a unique opportunity for investors to react to news"
				/>
				<NewsCard
					card-type="trending-list"
					title="Pre-market trading offers a unique opportunity for investors to react to news"
				/>
				<NewsCard
					card-type="trending-list"
					title="Pre-market trading offers a unique opportunity for investors to react to news"
				/>
				</template> -->
			</div>
		</Container>
	</section>

	<Head>
		<Title>StocksToTrade | News</Title>
		<Link
			rel="canonical"
			:href="current_hostname + 'news/'"
		/>

		<Meta
			name="description"
			content="StocksToTrade News is your go-to source for real-time stock market updates, laser-focused on the key catalysts driving short-term price action. Designed for active traders and investors, we specialize in delivering actionable insights on volatile sectors—such as penny stocks—where rapid price movements create high-potential opportunities.
Our coverage includes breaking news on earnings reports, mergers and acquisitions, FDA approvals, new contracts, and unusual trading volume—factors that often serve as the spark for significant price swings. Whether you're deciphering sudden stock movements or conducting in-depth research into potential investments, StocksToTrade News equips you with the information you need to stay ahead.
From beginners learning the ropes to seasoned traders refining their strategies, our audience relies on StocksToTrade News for expert analysis, practical tools, and educational insights. We also delve into market psychology, helping traders understand how catalysts like news events or sector momentum drive short-term stock price trends.
If you're a day trader hunting for the next breakout stock or an investor performing due diligence before taking a position, StocksToTrade News is your trusted partner for making smarter, faster, and more informed trading decisions. Stay ahead of the market with the insights you need to succeed."
		/>
		<Meta
			property="og:description"
			content="StocksToTrade News is your go-to source for real-time stock market updates, laser-focused on the key catalysts driving short-term price action. Designed for active traders and investors, we specialize in delivering actionable insights on volatile sectors—such as penny stocks—where rapid price movements create high-potential opportunities.
Our coverage includes breaking news on earnings reports, mergers and acquisitions, FDA approvals, new contracts, and unusual trading volume—factors that often serve as the spark for significant price swings. Whether you're deciphering sudden stock movements or conducting in-depth research into potential investments, StocksToTrade News equips you with the information you need to stay ahead.
From beginners learning the ropes to seasoned traders refining their strategies, our audience relies on StocksToTrade News for expert analysis, practical tools, and educational insights. We also delve into market psychology, helping traders understand how catalysts like news events or sector momentum drive short-term stock price trends.
If you're a day trader hunting for the next breakout stock or an investor performing due diligence before taking a position, StocksToTrade News is your trusted partner for making smarter, faster, and more informed trading decisions. Stay ahead of the market with the insights you need to succeed."
		/>

		<template v-if="head_seo">
			<template
				v-for="(tag, i) in head_seo"
				:key="i"
			>
				<Meta
					v-if="tag[0].startsWith('og_')"
					:property="'og:' + tag[0].slice(3)"
					:content="tag[1][0].url || tag[1]"
				/>

				<Meta
					v-else-if="tag[0].startsWith('article')"
					:property="'article:' + tag[0].slice(8)"
					:content="tag[1]"
				/>
				<Meta
					v-else-if="tag[0] !== 'twitter_misc' && tag[0].startsWith('twitter')"
					:name="'twitter:' + tag[0].slice(8)"
					:content="tag[1]"
				/>

				<template v-else-if="tag[0] === 'twitter_misc'">
					<Meta
						:name="'twitter:label1'"
						:content="Object.keys(tag[1])[0]"
					/>
					<Meta
						:name="'twitter:data2'"
						:content="Object.values(tag[1])[0]"
					/>
					<Meta
						:name="'twitter:label2'"
						:content="Object.keys(tag[1])[1]"
					/>
					<Meta
						:name="'twitter:data1'"
						:content="Object.values(tag[1])[1]"
					/>
				</template>

				<Meta
					v-else-if="tag[0] != 'og_image'"
					:name="tag[0]"
					:content="tag[1]"
				/>
				<template v-else>
					<Meta
						:property="tag[0].split('_').join(':') + ':type'"
						:content="tag[1][0].type"
					/>
					<Meta
						:property="tag[0].split('_').join(':')"
						:content="tag[1][0].url"
					/>
					<Meta
						:property="tag[0].split('_').join(':') + ':width'"
						:content="tag[1][0].width"
					/>
					<Meta
						:property="tag[0].split('_').join(':') + ':height'"
						:content="tag[1][0].height"
					/>
				</template>
			</template>
		</template>
	</Head>
</template>

<script setup>
import axios from "axios";
import { load } from "cheerio";
import MD5 from "crypto-js/md5";
import dayjs from "dayjs";
const $route = useRoute();
const $route_name = ref("");
const showAds = ref(false);
const showLoad = ref(false);
const news_pagination = reactive({
	page: 1,
	current_page: 1,
	total_pages: 1,
	previous_page: 0
});
const posts = ref([]);
const loadMore = ref(false);
const loadMoreAnchor = ref();
const route_name = ref("");
const isPushStatePending = ref(false);
const hostname = useRuntimeConfig().public.hostname;
const { current_hostname } = useRuntimeConfig().public;
const { $postsListDict } = useNuxtApp();

const NEWS_ENDPOINT = `wp-json/wp/v2/news?status=publish&per_page=20`;

const isLoading = ref(true);
const head_seo = computed(() => {
	if (yoast_head_json) {
		const filtered = Object.entries(yoast_head_json)
			.filter(
				(item) =>
					![
						"title",
						"robots",
						"canonical",
						"schema_json",
						"description",
						"og_description",
						"WordPressAuthor_YoastHeadJson_Schema_"
					].includes(item[0])
			)
			.map((item) => {
				if (item[0] === "og_image") {
					item[1][0].url = current_hostname + "images/block-ready-bg.jpg";
				}

				return item;
			});

		return filtered;
	}

	return null;
});
const list_of_symbols = ref([]);
const { data } = await useAsyncData("page_seo_data", async ({ $config }) => {
	const { headers } = await axios.get(`${hostname}${NEWS_ENDPOINT}`);

	const newsPostsDict = Object.values($postsListDict)
		.filter((item) => item.type === "news")
		.slice(0, 20)
		.map((post) => {
			let new_content;

			if (post.content) {
				new_content = load(post.content, {
					decodeEntities: false
				}).text();
			} else {
				new_content = "";
			}

			return {
				title: post.title ?? "",
				lastmod: post.lastmod,
				date: post.date,
				slug: post.slug,
				content: new_content,
				reading_time: post.content_read_time,
				image: post.image
			};
		});

	const { data } = await axios.get(`${hostname}wp-json/wp/v2/pages/23037/`);

	const { yoast_head_json, yoast_meta } = data;
	const { schema_json } = data.yoast_head_json;

	const total_pages = Number(headers["x-wp-totalpages"]);

	const pages_number = 1;

	let parsed_schema;
	if (schema_json) {
		parsed_schema = JSON.parse(schema_json);
		const parsed_schema_id = parse_saswpSchema(
			parsed_schema["@graph"],
			$config.public.hostname,
			$config.public.current_hostname
		);

		parsed_schema["@graph"] = parsed_schema_id;
	}

	const schema_stuff = {
		"@context": "https://schema.org",
		"@graph": [
			{
				"@type": ["WebPage", "CollectionPage"],
				"@id": $config.public.current_hostname + "news/",
				url: $config.public.current_hostname + "news/",
				name: "StocksToTrade | News",
				isPartOf: {
					"@id": $config.public.current_hostname + "#website"
				},
				primaryImageOfPage: {
					"@id": "https://content.stockstotrade.com/news/#primaryimage"
				},
				image: {
					"@id": $config.public.hostname + "news/#primaryimage"
				},
				thumbnailUrl:
					"https://content.stockstotrade.com//images/block-ready-bg.jpg",
				datePublished: "2024-09-12T10:10:00Z",
				dateModified: "2024-09-12T10:10:00Z",
				description: `StocksToTrade News is your go-to source for real-time stock market updates, laser-focused on the key catalysts driving short-term price action. Designed for active traders and investors, we specialize in delivering actionable insights on volatile sectors—such as penny stocks—where rapid price movements create high-potential opportunities.

Our coverage includes breaking news on earnings reports, mergers and acquisitions, FDA approvals, new contracts, and unusual trading volume—factors that often serve as the spark for significant price swings. Whether you're deciphering sudden stock movements or conducting in-depth research into potential investments, StocksToTrade News equips you with the information you need to stay ahead.

From beginners learning the ropes to seasoned traders refining their strategies, our audience relies on StocksToTrade News for expert analysis, practical tools, and educational insights. We also delve into market psychology, helping traders understand how catalysts like news events or sector momentum drive short-term stock price trends.

If you're a day trader hunting for the next breakout stock or an investor performing due diligence before taking a position, StocksToTrade News is your trusted partner for making smarter, faster, and more informed trading decisions. Stay ahead of the market with the insights you need to succeed.`,
				breadcrumb: {
					"@id": $config.public.current_hostname + "news/#breadcrumb"
				},
				inLanguage: "en-US"
			},
			{
				"@type": "ImageObject",
				inLanguage: "en-US",
				"@id": $config.public.hostname + "news/#primaryimage",
				url: $config.public.hostname + "images/block-ready-bg.jpg",
				contentUrl: "https://content.stockstotrade.com//images/block-ready-bg.jpg",
				width: 1000,
				height: 721
			},
			{
				"@type": "BreadcrumbList",
				"@id": $config.public.current_hostname + "news/#breadcrumb",
				itemListElement: [
					{
						"@type": "ListItem",
						position: 1,
						name: "Home",
						item: $config.public.current_hostname + ""
					},
					{ "@type": "ListItem", position: 2, name: "News &#8211; Timothy Sykes" }
				]
			},
			{
				"@type": "WebSite",
				"@id": $config.public.current_hostname + "#website",
				url: $config.public.current_hostname + "",
				name: "Timothy Sykes",
				description: "How To Trade Penny Stocks Without The Stock Promoter BS",
				publisher: {
					"@id":
						$config.public.current_hostname +
						"#/schema/person/9acd0cdbfa16f9846109176e93fd4ac4"
				},

				inLanguage: "en-US"
			},
			{
				"@type": ["Person", "Organization"],
				"@id":
					$config.public.current_hostname +
					"#/schema/person/9acd0cdbfa16f9846109176e93fd4ac4",
				name: "Timothy Sykes",
				image: {
					"@type": "ImageObject",
					inLanguage: "en-US",
					"@id": $config.public.hostname + "#/schema/person/image/",
					url: "https://content.timothysykes.com/wp-content/uploads/2016/09/timothy-sykes-665x385.jpg",
					contentUrl:
						"https://content.timothysykes.com/wp-content/uploads/2016/09/timothy-sykes-665x385.jpg",
					width: 665,
					height: 385,
					caption: "Timothy Sykes"
				},
				logo: {
					"@id": $config.public.hostname + "#/schema/person/image/"
				},
				sameAs: [
					$config.public.current_hostname + "blog/author/timothysykes/",
					"https://x.com/timothysykes",
					"https://news.google.com/publications/CAAqBwgKMJbmngswsvC2Aw?hl=en-US&gl=US&ceid=US%3Aen"
				]
			}
		]
	};

	return {
		yoast_head_json,
		yoast_meta,
		schema_json: schema_stuff,
		list: newsPostsDict,
		// list: news_list,
		pagination_stuff: {
			pageNumber: pages_number,
			previousPageNumber: pages_number > 1 ? pages_number - 1 : null,
			total_pages
		}
	};
});

if (!data.value) {
	throw createError({
		statusCode: 404,
		statusMessage: "Page Not Found",
		fatal: true
	});
}

const { yoast_head_json, schema_json, list, pagination_stuff } = data.value;

const pageObserver = () => {
	const observer = new IntersectionObserver(
		function (entry) {
			if (entry[0].isIntersecting === true) {
				const page_num = Number(entry[0].target.getAttribute("data-page"));

				if (page_num && page_num > 0) {
					let url;

					const regex = /^\/news\/page\/\d+\/$/;

					if (route_name === "/news/" || regex.test(route_name)) {
						url = page_num === 1 ? "/news/" : "/news/page/" + page_num + "/";
					} else {
						let page_url = window.location.pathname;
						page_url = page_url.split("page")[0];

						url = page_num === 1 ? page_url : page_url + "page/" + page_num + "/";
					}

					if (!isPushStatePending.value) {
						history.pushState({}, null, url);
					}
					isPushStatePending.value = true;
					setTimeout(() => {
						isPushStatePending.value = false;
					}, 500);
				}
			}
		},
		{ threshold: [0] }
	);

	document.querySelectorAll(".post-tile").forEach((entry) => {
		observer.observe(entry);
	});
};

const isElementInViewport = (element) => {
	if (!element) {
		return false;
	}

	const rect = element.getBoundingClientRect();
	return rect.bottom > 0 && rect.top < window.innerHeight;
};

const loadMorePost = () => {
	loadMore.value = false;
	const next_page = news_pagination.current_page + 1;

	let posts_arr = Object.entries($postsListDict)
		.filter(([_, value]) => value.type === "news")
		.map(([_, value]) => value);

	const number = Number(next_page);

	posts_arr = posts_arr.slice(number * 20, number * 20 + 20);

	const posts_formatted = posts_arr.map((post) => {
		return {
			...post,
			page: next_page,
			date: post.lastmod ?? post.date,
			image:
				"https://content.timothysykes.com/cdn-cgi/image/quality=90,format=webp,width=740/" +
				post.image
		};
	});

	posts_formatted.forEach((post) => {
		posts.value.push(post);
	});

	news_pagination.current_page = next_page;

	setTimeout(() => (loadMore.value = true), 250);
};

const loadMorePostBackwards = () => {
	const previous_page = news_pagination?.previous_page;

	loadMore.value = false;

	let posts_arr = Object.entries($postsListDict)
		.filter(([_, value]) => value.type === "news")
		.map(([_, value]) => value);

	const number = Number(previous_page);
	posts_arr = posts_arr.slice(0, number * 20);

	const posts_formatted = posts_arr.map((post) => {
		return {
			...post,
			page: previous_page,
			date: post.lastmod ?? post.date,
			image:
				"https://content.timothysykes.com/cdn-cgi/image/quality=90,format=webp,width=740/" +
				post.image
		};
	});

	posts_formatted.forEach((post) => {
		posts.value.unshift(post);
	});

	setTimeout(() => {
		const total_gap_per_row = 32 * 5;
		const total_tile_height_per_row = 292 * 5;
		const total_blog_header_space = 44 + 172;

		window.scrollTo(
			0,
			total_tile_height_per_row + total_gap_per_row + total_blog_header_space
		);
		news_pagination.previous_page = previous_page - 1;

		loadMore.value = true;
	}, 250);
};

const isAtTop = () => {
	return window.scrollY === 0;
};

const handleVisibilityChange = () => {
	const visibilityCheck = isElementInViewport(loadMoreAnchor.value);

	if (
		isAtTop() &&
		loadMore.value === true &&
		news_pagination.previous_page > 0 &&
		news_pagination.current_page !== 1
	) {
		loadMorePostBackwards();
	}

	if (
		news_pagination.current_page <= news_pagination.total_pages &&
		visibilityCheck &&
		loadMore.value === true
		// &&this.currentPage != this.totalPages
	) {
		showLoad.value = true;
		loadMore.value = false;
		loadMorePost();
	}
};

const scrollSuperThing = () => {
	if (/^\/news\/[^/]+\/?$/.test(window.location.pathname)) {
		window.removeEventListener("scroll", scrollSuperThing);

		return;
	}

	handleVisibilityChange();
	pageObserver();
};

watch($route, (newPath, oldPath) => {
	if (process.client) {
		if (newPath !== oldPath) {
			window.removeEventListener("scroll", scrollSuperThing);
		}

		showAds.value = window.adsAreWithUs;
	}
});

onMounted(async () => {
	$route_name.value = $route.name;

	news_pagination.page = pagination_stuff.pageNumber;
	news_pagination.total_pages = pagination_stuff.total_pages;
	news_pagination.previous_page = pagination_stuff.pageNumber - 1;
	news_pagination.current_page = pagination_stuff.pageNumber;

	if (list) {
		posts.value = list.map(
			({ title, reading_time, date, slug, content, image }) => ({
				title,
				reading_time,
				date,
				slug,
				description: content,
				image,
				content
			})
		);
	}

	if (process.client) {
		route_name.value = window.location.pathname;

		const date = dayjs(Date.now()).format("ddd, D MMM YYYY");

		const secretToken = MD5(date).toString();

		const headers = {
			secretToken
		};

		const getStocksInfo = [
			"QBTS",
			"ACHR",
			"WULF",
			"RGTI",
			"BITF",
			"SOUN",
			"RIOT",
			"OPEN"
		].map(async (symbol) => {
			const data = {
				filter: `SYMBOL IN ('${symbol}')`,
				prevDay: false,
				fields:
					"VOLUME, TRADES, FLOAT, SHORT_INTEREST,SHORT_INTEREST_RATIO, SYMBOL, NAME, LAST, NET_CHG, PC_CHG, MARKET_CAP, HIGH_52W, LOW_52W, LOW, HIGH, DAY_RANGE, MARKET"
			};

			return await axios.post(
				"https://app02.stockstotrade.com:8094/v1.1/symbols",
				data,
				{
					headers
				}
			);
		});

		Promise.all(getStocksInfo).then((res) => {
			res.forEach((r) => {
				if (r.data[0]) {
					list_of_symbols.value.push(r.data[0]);
				}
			});
		});
	}

	if (list && process.client) {
		isLoading.value = false;

		await setTimeout(() => window.scrollTo(0, 1), 1000);

		window.addEventListener("scroll", scrollSuperThing, { passive: true });

		if (news_pagination.current_page < news_pagination.total_pages) {
			loadMore.value = true;
		}

		showAds.value = window.adsAreWithUs;
	}
});

useHead({
	script: [
		{
			type: "application/ld+json",
			class: "saswp-schema-markup-output",
			innerHTML: JSON.stringify(schema_json)
		}
	]
});
</script>
